<app-header></app-header>
<div class="container">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../../assets/img/datos.jpg" class="d-block myimg"  >
          </div>
          <div class="carousel-item">
            <img src="../../assets/img/datos.jpg" class="d-block myimg" >
          </div>
          <div class="carousel-item">
            <img src="../../assets/img/sistemas.jpg" class="d-block myimg" >
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
</div>

<app-footer></app-footer>

